import { SubscriptionIntegrationSchema } from "@redotech/redo-model/subscription-integrations/subscription-integration";
import * as z from "zod/v4";

export const editSubscriptionAddress = {
  name: "editSubscriptionAddress" as const,
  input: z.object({
    subscriptionId: z.number(),
    address: z.object({
      address1: z.string(),
      address2: z.string().optional(),
      city: z.string(),
      province: z.string(),
      zip: z.string(),
      country: z.string(),
    }),
  }),
  output: z.object({
    subscription: SubscriptionIntegrationSchema,
  }),
};
